/* eslint-disable @stylistic/comma-dangle */

import { SharedLocale }	from "@geotoura/shared/sharedLocale";
import { siteInfo }		from "@geotoura/shared/siteInfo_en";

const page	= {
	privacyHint: {
		href:	siteInfo.page.privacyHint,
		text:	"privacy notice"
	},
	featured: [
		{
			href:	`/${siteInfo.wordpressBase}/travel-lab/`,
			text:	"Travel lab"
		},
		{
			href:	`/${siteInfo.wordpressBase}/tours-with-your-own-car/`,
			text:	"Tours with your own car"
		},
	],
};

export const sharedLocale:SharedLocale	= {
	phone: {
		href:	`tel:${siteInfo.phone.machine}`,
		text:	siteInfo.phone.human
	},
	email: {
		info:	{
			href:	`mailto:${siteInfo.email.info}`,
			text:	siteInfo.email.info
		},
		reisen:	{
			href:	`mailto:${siteInfo.email.reisen}`,
			text:	siteInfo.email.reisen
		}
	},
	page: page,
	privacyAgreement: {
		pre:	"I have read and accept the ",
		link:	page.privacyHint,
		post:	"."
	}
};
